const Incident = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="4" fill="#F26141"/>
<g clip-path="url(#clip0_4945_24983)">
<path d="M8.33337 3.33398L3.33337 10.0007H8.33337L5.00004 16.6673L16.6667 8.33398H10L15 3.33398H8.33337Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4945_24983">
<rect width="13.3333" height="13.3333" fill="white" transform="translate(3.33337 3.33398)"/>
</clipPath>
</defs>
</svg>
  );
};  

export default Incident;
